/* eslint-disable */
// @ts-nocheck
import React from 'react';
import { QUERY_VALUE_OPTIONS_BOOLEAN, QUERY_VALUE_OPTIONS_OS } from './constants';
import { flatASTToLuceneString, assertNonInvertible } from './luceneTransform';
import { LuceneResult } from './LuceneResult';
import AddFieldButton from '../AddFieldButton';
import QueryPart from './QueryPart';
import QueryPartState from './QueryPartState';
import type { FlatAsts } from '../../../types/luceneTypes';
import type { AgencyAccessFilters } from '../../../../main/types/utilTypes';
import type { FilterTypeOption, OptionWithLuceneQueryBuilderConfig } from './types';
import {
  getSortedOptions,
  parseFlattenSimplifyAndValidateLucene,
  removeDefaultQueries,
} from '../../../../main/components/PartnerManager/components/PostbackForm/PostbackDataMapper/FilterService/FiltersService';
export const OPTIONS: OptionWithLuceneQueryBuilderConfig[] = [
  {
    label: 'Ad Partner',
    value: 'last_attributed_touch_data.$3p',
  },
  {
    label: 'Attributed',
    value: 'attributed',
    config: {
      defaultQueryValueOptions: QUERY_VALUE_OPTIONS_BOOLEAN,
      singleValueDropdown: true,
    },
  },
  {
    label: 'Campaign',
    value: 'last_attributed_touch_data.~campaign',
  },
  {
    label: 'Channel',
    value: 'last_attributed_touch_data.~channel',
  },
  {
    label: 'Country',
    value: 'user_data.geo_country_code',
  },
  {
    label: 'Custom',
    value: '_custom_',
  },
  {
    label: 'Feature',
    value: 'last_attributed_touch_data.~feature',
  },
  {
    label: 'LAT enabled',
    value: 'user_data.limit_ad_tracking',
    config: {
      defaultQueryValueOptions: QUERY_VALUE_OPTIONS_BOOLEAN,
      singleValueDropdown: true,
    },
  },
  {
    label: 'Tags',
    value: 'last_attributed_touch_data.~tags',
  },
  {
    label: 'Last Attributed Touch ID',
    value: 'last_attributed_touch_data.~id',
  },
  {
    label: 'Last Attributed Touch Type',
    value: 'last_attributed_touch_type',
  },
  {
    label: 'Operating System',
    value: 'user_data.os',
    config: {
      defaultQueryValueOptions: QUERY_VALUE_OPTIONS_OS,
    },
  },
  {
    label: 'Environment',
    value: 'user_data.environment',
  },
  {
    label: 'Platform',
    value: 'user_data.platform',
  },
  {
    label: 'Agency ID',
    value: 'last_attributed_touch_data.~agency_id',
  },
  {
    label: 'Reengagement Activity Attributed',
    value: 'reengagement_activity.attributed',
  },
  {
    label: 'Customer Event Alias',
    value: 'customer_event_alias',
  },
  {
    label: 'First Event For User',
    value: 'first_event_for_user',
  },
];
const FILTER_TYPE_OPTIONS: Array<FilterTypeOption> = [
  {
    label: 'equals',
    value: 'equals',
  },
  {
    label: 'does not equal',
    value: 'not_equals',
  },
  {
    label: 'contains',
    value: 'contains',
  },
  {
    label: 'does not contain',
    value: 'not_contains',
  },
  {
    label: 'starts with',
    value: 'starts_with',
  },
  {
    label: 'does not start with',
    value: 'not_starts_with',
  },
  {
    label: 'ends with',
    value: 'ends_with',
  },
  {
    label: 'does not end with',
    value: 'not_ends_with',
  },
  {
    label: 'exists',
    value: 'exists',
  },
  {
    label: 'does not exist',
    value: 'not_exists',
  },
  {
    label: 'in range',
    value: 'range',
  },
  {
    label: 'not in range',
    value: 'not_range',
  },
];
type Props = {
  queryString: string;
  onChange: (arg0: string) => void;
  filterDisplayKeys?: Array<string>;
  options: Array<OptionWithLuceneQueryBuilderConfig>;
  agencyId?: string | null | undefined;
  agencyUser?: boolean | null | undefined;
  getFilters: (filters: Array<FilterTypeOption>, field?: string | null | undefined) => Array<FilterTypeOption>;
  hasPrefixSyntax?: boolean | null | undefined;
  readingMode: boolean;
  accessFilters?: AgencyAccessFilters | null | undefined;
  isWebhook: boolean;
  isRuleValid?: (ruleValid: boolean) => void;
  queryValueOptions?: Record<string, string[]>;
};
type State = {
  initQueryErrors: string | null | undefined;
  queryChangeErrors: string | null | undefined;
  removedQueries: FlatAsts;
  queryPartStates: Array<QueryPartState>;
};

class LuceneQueryBuilder extends React.Component<Props, State> {
  static defaultProps = {
    queryString: 'NOT user_data.os:"ROBOTS"',
    filterDisplayKeys: [],
    options: OPTIONS,
    getFilters: () => FILTER_TYPE_OPTIONS,
    hasPrefixSyntax: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      initQueryErrors: null,
      queryChangeErrors: null,
      removedQueries: [],
      queryPartStates: [],
    };
  }

  componentDidMount(): void {
    const { isRuleValid } = this.props;

    const result = this._parseFlattenSimplifyAndValidateLucene();

    if (result instanceof Error) {
      return this.setState(
        {
          initQueryErrors: result.message,
        },
        isRuleValid && isRuleValid(false)
      );
    }

    const { removedQueries, flatAstWithoutDefaults } = this._removeDefaultQueries(result);

    const queryPartStates = flatAstWithoutDefaults.map(QueryPartState.fromPart);

    if (!queryPartStates.length) {
      isRuleValid && isRuleValid(false);
    }

    this.setState({
      removedQueries,
      queryPartStates,
    });
  }

  componentDidUpdate(prevProps: Props): void {
    // if the queryString doesn't change, AND if we are not switching between read-only and
    // edit- modes, there's no need to update the queryParts
    const { queryString, readingMode, isRuleValid } = this.props;

    if (prevProps.queryString === queryString && prevProps.readingMode === readingMode) {
      return;
    }

    const result = this._parseFlattenSimplifyAndValidateLucene();

    if (result instanceof Error) {
      return this.setState(
        {
          initQueryErrors: result.message,
        },
        isRuleValid && isRuleValid(false)
      );
    }

    const { removedQueries, flatAstWithoutDefaults } = this._removeDefaultQueries(result);

    const queryPartStates = flatAstWithoutDefaults.map(QueryPartState.fromPart);

    if (!queryPartStates.length) {
      isRuleValid && isRuleValid(false);
    }

    this.setState({
      removedQueries,
      queryPartStates,
    });
  }

  _removeDefaultQueries = (flatAst: FlatAsts): Record<string, FlatAsts> => {
    const { filterDisplayKeys } = this.props;
    return removeDefaultQueries(flatAst, filterDisplayKeys);
  };

  _clearErrors = () => {
    const { isRuleValid } = this.props;
    this.setState(
      {
        initQueryErrors: null,
        queryChangeErrors: null,
      },
      isRuleValid && isRuleValid(true)
    );
  };

  _convertToLuceneAndUpdate = () => {
    const { isRuleValid, onChange } = this.props;
    const { queryPartStates, removedQueries } = this.state;
    const hasIncompleteQueryPartState = queryPartStates.some((queryPartState) => {
      // toFlatAst returns undefined if queryPartState isn't complete/legal
      return !queryPartState.toFlatAst();
    });
    const mergedQueryPartStates = QueryPartState.consolidateQueryPartStates(queryPartStates);
    const flatAsts = QueryPartState.toFlatAsts(mergedQueryPartStates);

    // flatAsts is undefined if any part of conversion from
    // merged QeryPartStates to flatAsts fails
    if (hasIncompleteQueryPartState || !flatAsts) {
      const message = 'One or more rows is incomplete; please update query';
      return this.setState(
        {
          queryChangeErrors: message,
        },
        isRuleValid && isRuleValid(false)
      );
    }

    const builtLucene = LuceneResult.ok(removedQueries.concat(flatAsts)).map(flatASTToLuceneString);
    const validationResultError = builtLucene.map(assertNonInvertible).getError();

    if (validationResultError) {
      return this.setState(
        {
          queryChangeErrors: validationResultError.message,
        },
        isRuleValid && isRuleValid(false)
      );
    }

    const builtLuceneValue = builtLucene.value();

    if (builtLuceneValue instanceof Error) {
      return this.setState(
        {
          queryChangeErrors: builtLuceneValue.message,
        },
        isRuleValid && isRuleValid(false)
      );
    }

    onChange(builtLuceneValue);

    this._clearErrors();
  };

  _onQueryPartChange = (index: number, queryPartState: QueryPartState): void => {
    const newQueryPartStates = this.state.queryPartStates;
    newQueryPartStates[index] = queryPartState;
    this.setState(
      {
        queryPartStates: newQueryPartStates,
      },
      this._convertToLuceneAndUpdate
    );
  };

  _onQueryPartDelete = (index: number): void => {
    const { isRuleValid } = this.props;
    const { queryPartStates } = this.state;
    const newQueryPartStates = queryPartStates.slice(0, index).concat(queryPartStates.slice(index + 1));

    if (!newQueryPartStates.length) {
      isRuleValid && isRuleValid(false);
    }

    this.setState(
      {
        queryPartStates: newQueryPartStates,
      },
      this._convertToLuceneAndUpdate
    );
  };

  _addNewPart = (): void => {
    const newQueryPartStates = this.state.queryPartStates;
    const queryPartState = new QueryPartState({
      terms: [],
      field: '',
      type: 'equals',
      termMin: null,
      termMax: null,
    });
    newQueryPartStates.push(queryPartState);
    this.setState(
      {
        queryPartStates: newQueryPartStates,
      },
      this._convertToLuceneAndUpdate
    );
  };

  _renderErrors(error: string) {
    return <div className="h_mb-10">{error}</div>;
  }

  _parseFlattenSimplifyAndValidateLucene = (): FlatAsts | Error => {
    const { queryString, hasPrefixSyntax } = this.props;
    return parseFlattenSimplifyAndValidateLucene(hasPrefixSyntax, queryString);
  };

  _renderAddFieldButton = () => {
    return (
      <div
        style={{
          marginLeft: '-5px',
        }}
      >
        <AddFieldButton testid="add-filter" onClick={this._addNewPart}>
          Add Filter
        </AddFieldButton>
      </div>
    );
  };

  render() {
    const { readingMode, agencyId, agencyUser, getFilters, accessFilters, isWebhook, queryValueOptions } = this.props;
    const { initQueryErrors, queryChangeErrors, queryPartStates } = this.state;

    if (initQueryErrors) {
      return this._renderErrors(initQueryErrors);
    }

    return (
      <div className="lucene-query-builder__container" data-testid="lucene-query-builder__container">
        {queryChangeErrors && this._renderErrors(queryChangeErrors)}
        {queryPartStates.reduce((acc, queryPartState, i) => {
          return acc.concat([
            readingMode ? <span key={`rule-connector-${i}`}>{i ? ' and ' : ''}</span> : null,
            <QueryPart
              queryPartState={queryPartState}
              key={`${i}_${queryPartState.field}`}
              index={i}
              agencyId={agencyId}
              agencyUser={agencyUser}
              options={getSortedOptions(this.props.options)}
              getFilters={(field) => getFilters(FILTER_TYPE_OPTIONS, field)}
              onChange={(queryPartState) => this._onQueryPartChange(i, queryPartState)}
              onDelete={() => this._onQueryPartDelete(i)}
              convertToHumanReadable={readingMode}
              accessFilters={accessFilters}
              isWebhook={isWebhook}
              queryValueOptions={queryValueOptions}
            />,
          ]);
        }, [])}
        {readingMode ? null : this._renderAddFieldButton()}
      </div>
    );
  }
}

export default LuceneQueryBuilder;
